<template>
  <div class="firstStep">
    <a-form-model layout="inline" :model="searchForm">
      <a-form-model-item label="游戏名称">
        <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.name" placeholder="请输入游戏名称" />
      </a-form-model-item>
      <a-form-item label="质量标准" v-if="searchForm.contentType == 1">
        <a-select allowClear v-model="searchForm.classifyTag" placeholder="请选择质量标准" style="width: 180px">
          <a-select-option :value="1">商用</a-select-option>
          <a-select-option :value="4">科研</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-model-item label="版本名称">
        <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.versionName" placeholder="请输入版本名称" />
      </a-form-model-item>
      <a-form-model-item label="一级能力" v-if="searchForm.contentType == 4">
        <a-tree-select v-model="searchForm.FirstAbilityId" treeDefaultExpandAll style="width: 172px" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="选择一级能力" allow-clear>
          <a-tree-select-node :key="items.id" :title="items.name" :value="items.id" v-for="items in treeData" :selectable="false">
            <template v-if="items.children">
              <a-tree-select-node :key="item.id" :title="item.name" :value="item.id" v-for="item in items.children">
                <template v-if="item.children">
                  <a-tree-select-node :key="el.id" :title="el.name" :value="el.id" v-for="el in item.children" />
                </template>
              </a-tree-select-node>
            </template>
          </a-tree-select-node>
        </a-tree-select>
      </a-form-model-item>
      <a-form-model-item label="能力维度" v-else>
        <a-cascader v-model="selectId" style="width: 250px" :options="options" :load-data="loadData" placeholder="请选择能力维度" change-on-select @change="onChange" />
      </a-form-model-item>
      <a-form-model-item>
        <a-button @click="getPageList(1)" type="primary" html-type="button"> 查询 </a-button>
      </a-form-model-item>
    </a-form-model>
    <a-tabs v-model="searchForm.contentType" @change="changeTab">
      <a-tab-pane :key="1" tab="添加测评游戏" />
      <a-tab-pane :key="2" tab="添加训练游戏" />
      <a-tab-pane :key="3" tab="添加题目壳" />
      <a-tab-pane :key="4" tab="添加视频" />
      <a-tab-pane :key="5" tab="添加亲子游戏" />
    </a-tabs>
    <a-table
      style="min-width: 800px"
      :columns="columns"
      :scroll="{ y: 300 }"
      :row-selection="rowSelection"
      rowKey="id"
      :pagination="tableRelevant.tablePagination"
      :loading="tableRelevant.tableLoading"
      :locale="tableRelevant.locale"
      :dataSource="tableRelevant.tableDataSource"
    >
      <div slot="classifyTag" slot-scope="text">
        <span style="color: green" v-if="text.classifyTag == 1">商用</span>
        <span style="color: #f90" v-else-if="text.classifyTag == 4">科研</span>
        <span v-else>--</span>
      </div>
      <div slot="device" slot-scope="text, record">
        <span v-for="item in hardwareList" :key="item.id">
          <img style="width: 20px; margin-left: 10px" :src="item.icon" alt="" v-if="(item.id | text.hardwareRequirements) == text.hardwareRequirements" />
        </span>
      </div>
      <div slot="estimatedTime" slot-scope="text">
        {{ EstimatedTime(text.estimatedTime) }}
      </div>
      <div slot="ages" slot-scope="text">
        {{ text.minAge + ' - ' + text.maxAge }}
      </div>
      <div slot="abilityTypeName" slot-scope="text">
        <div class="self_td" v-for="item in text.contentAbility" :key="item.id">
          {{ item.abilityTypeName }}- {{ item.firstAbilityName }}-
          {{ item.secondAbilityName }}
        </div>
      </div>
      <div slot="firstAbility" slot-scope="text" class="table-ability">
        <div v-for="item in text.contentAbility">
          {{ item.firstAbilityName }}
        </div>
      </div>
    </a-table>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import { EstimatedTime } from '@/utils/EstimatedTime'

const columns = [
  {
    title: '名称',
    dataIndex: 'name',
  },
  {
    title: '版本名称',
    dataIndex: 'versionName',
  },
  { title: '质量标准', scopedSlots: { customRender: 'classifyTag' } },
  { title: '能力维度', class: 'testClass', key: 'abilityTypeName', width: 300, align: 'center', scopedSlots: { customRender: 'abilityTypeName' } },
  {
    title: '适用年龄',
    scopedSlots: { customRender: 'ages' },
  },
  {
    title: '预计用时',
    scopedSlots: { customRender: 'estimatedTime' },
  },
  { title: '设备要求', scopedSlots: { customRender: 'device' }, align: 'center', key: 'device' },
]
export default {
  name: 'firstStep',
  props: {
    abilityList: {
      type: Array,
      value: [],
    },
    pageData: {
      type: Object,
      value: {},
    },
  },
  data() {
    return {
      //设备
      hardwareList: [
        { id: 4, name: '耳机', icon: require('@/assets/img/ej.png') },
        { id: 8, name: '麦克风', icon: require('@/assets/img/mkf.png') },
        { id: 32, name: '陀螺仪', icon: require('@/assets/img/tly.png') },
      ],
      EstimatedTime,
      selectId: undefined,
      options: [],
      searchForm: {
        name: undefined,
        versionName: undefined,
        classifyTag: undefined,
        contentType: 1,
        AbilityTypeId: undefined,
        FirstAbilityId: undefined,
        SecondAbilityId: undefined,
      },
      columns,
      tableRelevant: tableRelevant.call(this),
      seriesInfo: this.$store.getters['course/getSeriesInfo'](),
      tableSelectedRowKeys: [],
      tableSelectedRows: [],

      treeData: [],
    }
  },
  computed: {
    rowSelection() {
      return {
        type: this.pageData.tableType || 'checkbox',
        selectedRowKeys: this.tableSelectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          const contentTypeName = ['', '测评游戏', '训练游戏', '题目壳', '课程视频', '亲子游戏']
          this.tableSelectedRowKeys = selectedRowKeys
          this.tableSelectedRows = this.tableSelectedRows.concat(selectedRows)
          this.tableSelectedRows = this.tableSelectedRowKeys.map((m) => {
            const item = this.tableSelectedRows.filter((f) => f.id === m)[0] || {}
            item.contentAbilitys = item.contentAbility
            item.executionsNumber = item.contentType === 2 ? 5 : 1
            item.contentDisplayOrder = 1
            item.contentTypeName = contentTypeName[item.contentType]
            item.isLinkVedio = false
            item.isSetting = true
            item.isRegularContent = false
            return item
          })
        },
      }
    },
  },
  mounted() {
    const pageData = JSON.parse(JSON.stringify(this.pageData))
    this.searchForm.contentType = pageData.contentType
    console.log(this.seriesInfo)

    this.tableSelectedRowKeys = pageData.selectedKeys
    this.tableSelectedRows = pageData.selectedRows
    this.getPageList(1)
    this.abilityTypeSelect(0)
    this.getSelect()
  },
  methods: {
    changeTab() {
      this.searchForm = {
        name: undefined,
        versionName: undefined,
        classifyTag: undefined,
        AbilityTypeId: undefined,
        FirstAbilityId: undefined,
        SecondAbilityId: undefined,
        contentType:this.searchForm.contentType
      }
      this.getPageList(1)
    },
    getSelect() {
      let params = {
        isSelect: true,
        abilityType: 0,
      }
      this.$http.loadallsel(params).then((res) => {
          this.treeData = res.data.data
      })
    },
    // 能力维度
    onChange(value) {
      this.searchForm.AbilityTypeId = value[0]
      this.searchForm.FirstAbilityId = value[1]
      this.searchForm.SecondAbilityId = value[2]
      this.selectId = value
    },
    loadData(selectedOptions) {
      return new Promise((resolve, reject) => {
        const targetOption = selectedOptions[selectedOptions.length - 1]
        targetOption.loading = true
        targetOption.children = []
        let params = {
          pid: targetOption.id,
          abilityType: 0,
        }
        this.$http.abilitySelect(params).then((res) => {
            targetOption.loading = false
            targetOption.children = res.data.data.map((m) => ({ ...m, value: m.id, label: m.name, isLeaf: m.levelNumber > 1 }))
            this.options = [...this.options]
            resolve(targetOption.children)
        })
      })
    },
    abilityTypeSelect(level) {
      let params = {
        level: level,
        abilityType: 0,
      }
      this.$http.abilitySelect(params).then((res) => {
          this.options = res.data.data
          this.options.forEach((item) => {
            item.value = item.id
            item.label = item.name
            item.isLeaf = false
          })
          if (this.searchForm.AbilityTypeId) {
            this.loadData(this.options.filter((f) => f.id === this.searchForm.AbilityTypeId)).then((data) => {
              if (this.searchForm.FirstAbilityId) {
                this.loadData(data.filter((f) => f.id === this.searchForm.FirstAbilityId))
              }
            })
          }
      })
    },
    getPageList(pageIndex) {
      if (this.searchForm.contentType < 3) {
        this.columns = [
          {
            title: '名称',
            dataIndex: 'name',
          },
          {
            title: '版本名称',
            dataIndex: 'versionName',
          },
          { title: '质量标准', scopedSlots: { customRender: 'classifyTag' } },
          { title: '能力维度', class: 'testClass', key: 'abilityTypeName', width: 300, align: 'center', scopedSlots: { customRender: 'abilityTypeName' } },
          {
            title: '适用年龄',
            scopedSlots: { customRender: 'ages' },
          },
          {
            title: '预计用时',
            scopedSlots: { customRender: 'estimatedTime' },
          },
          { title: '设备要求', scopedSlots: { customRender: 'device' }, align: 'center', key: 'device' },
        ]
      } else if (this.searchForm.contentType == 4) {
        this.columns = [
          { title: '视频名称', dataIndex: 'name', align: 'center' },
          { title: '版本名称', dataIndex: 'versionName', align: 'center' },
          { title: '视频类型', scopedSlots: { customRender: 'type' }, align: 'center' },
          { title: '一级能力', scopedSlots: { customRender: 'firstAbility' }, align: 'center' },
          { title: '适用年龄', scopedSlots: { customRender: 'ages' }, align: 'center' },
          { title: '预计用时', scopedSlots: { customRender: 'estimatedTime' }, align: 'center' },
          { title: '备注', dataIndex: 'remark', align: 'center' },
        ]
      } else {
        this.columns = [
          { title: '名称', dataIndex: 'name', align: 'center' },
          { title: '版本名称', dataIndex: 'versionName', align: 'center' },
          { title: '能力维度', class: 'testClass', key: 'abilityTypeName', width: 300, align: 'center', scopedSlots: { customRender: 'abilityTypeName' } },
          { title: '年龄范围', scopedSlots: { customRender: 'ages' }, align: 'center' },
          { title: '预计用时', scopedSlots: { customRender: 'estimatedTime' }, align: 'center', key: 'time' },
        ]
      }

      const params = {
        //courseSeriesId: this.seriesInfo.id,
        status: true,
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      }
      this.tableRelevant.tableLoading = true
      this.$http.contentPagelist(params).then((res) => {
        this.tableRelevant.tableLoading = false
        const { data, status, message } = res.data
          this.tableRelevant.tableDataSource = data.items
          this.tableRelevant.tablePagination.total = data.totalCount
          this.tableRelevant.tablePagination.current = data.pageIndex
       
      })
    },

    repeatArray(arr, key) {
      const nArr = []
      for (let i = 0; i < arr.length; i++) {
        let index = nArr.filter((f) => f[key] === arr[i][key])
        if (!index.length) {
          nArr.push(arr[i])
        }
      }
      return nArr
    },
  },
}
</script>

<style scoped lang="less">
.firstStep /deep/ .ant-table-body {
  height: 300px;
}

.table-ability div:not(:last-child) {
  padding-bottom: 32px;
}
/deep/ .ant-table-tbody .testClass {
  padding: 0 !important;
}
.self_td {
  height: 54px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  justify-content: center;
}
</style>
